/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "com.atproto.sync.getRecord";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"did":/*#__PURE__*/ l.string({"format":"did"}),"rkey":/*#__PURE__*/ l.string({"format":"record-key"}),"collection":/*#__PURE__*/ l.string({"format":"nsid"})});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("application/vnd.ipld.car");

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get data blocks needed to prove the existence or non-existence of record in the current version of repo. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["RecordNotFound","RepoNotFound","RepoTakendown","RepoSuspended","RepoDeactivated"]);

export { main };

export const $lxm = $nsid;
